"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDonutColorScale = exports.getTicksForDualAxisSize = exports.createMatchingDualLinearAxisScales = exports.getZoomButtonStateOnChartZoom = exports.getZoomButtonStateOnChartLoad = exports.getNewZoomState = exports.getNewZoomCursor = exports.onZoomOutButtonClick = exports.onScrollButtonClick = exports.onZoomInButtonClick = exports.resetZoom = exports.formatYears = exports.formatMonths = exports.formatLinearNumbers = exports.getChartTransformation = exports.getSVGHeight = exports.getSVGWidth = exports.getChartHeightWithMargin = exports.getChartWidthWithMargin = exports.getScaleByType = void 0;
var tslib_1 = require("tslib");
var d3 = tslib_1.__importStar(require("d3"));
var date_fns_1 = require("date-fns");
exports.getScaleByType = function (axisType, domain, range, padding) {
    switch (axisType) {
        case 'LINEAR':
            return d3.scaleLinear().domain(domain).range(range);
        case 'MONTH':
            return d3.scaleTime().domain(domain).range(range);
        case 'BAND':
            return d3
                .scaleBand()
                .domain(domain)
                .range(range)
                .padding(padding !== null && padding !== void 0 ? padding : 0);
        default:
            return d3.scaleLinear().domain(domain).range(range);
    }
};
exports.getChartWidthWithMargin = function (width, chartMargin) {
    return width - chartMargin.left - chartMargin.right;
};
exports.getChartHeightWithMargin = function (height, chartMargin) {
    return height - chartMargin.top - chartMargin.bottom;
};
exports.getSVGWidth = function (chartWidth, chartMargin) {
    return chartWidth + chartMargin.left + chartMargin.right;
};
exports.getSVGHeight = function (chartHeight, chartMargin) {
    return chartHeight + chartMargin.top + chartMargin.bottom;
};
exports.getChartTransformation = function (chartMargin) {
    return "translate(" + chartMargin.left + ", " + chartMargin.top + ")";
};
exports.formatLinearNumbers = function (number, precision) {
    if (precision === void 0) { precision = 2; }
    if (number >= 1000 || number <= -1000) {
        return d3
            .format('.3s')(number)
            .replace(/G/, ' B')
            .replace(/k/, ' k')
            .replace(/M/, ' M');
    }
    return number === null || number === void 0 ? void 0 : number.toFixed(precision);
};
exports.formatMonths = function (date, i, ticks, interval) {
    if (i > 0 &&
        date_fns_1.getYear(ticks[i - interval]) === date_fns_1.getYear(date) &&
        date_fns_1.getMonth(ticks[i - interval]) === date_fns_1.getMonth(date)) {
        return '';
    }
    return d3.timeFormat('%b')(date);
};
exports.formatYears = function (date, i, ticks, interval) {
    if (i > 0 && date_fns_1.getYear(ticks[i - interval]) === date_fns_1.getYear(date)) {
        return '';
    }
    return d3.timeFormat('%Y')(date);
};
exports.resetZoom = function (zoomBehavior, SVGElement) {
    zoomBehavior.transform(d3.select(SVGElement).transition().duration(750), d3.zoomIdentity);
};
exports.onZoomInButtonClick = function (zoomBehavior, SVGElement, zoomFactor) {
    zoomBehavior.scaleBy(d3
        .select(SVGElement)
        .transition()
        .duration(750), zoomFactor);
};
exports.onScrollButtonClick = function (zoomBehavior, SVGElement, scrollFactor) {
    zoomBehavior.translateBy(d3
        .select(SVGElement)
        .transition()
        .duration(450), scrollFactor, 0);
};
exports.onZoomOutButtonClick = function (zoomBehavior, SVGElement, zoomFactor) {
    zoomBehavior.scaleBy(d3
        .select(SVGElement)
        .transition()
        .duration(750), 1 / zoomFactor);
};
exports.getNewZoomCursor = function (eventType) {
    return eventType === 'mousemove' ? 'grabbing' : 'grab';
};
exports.getNewZoomState = function (SVGElement) {
    return d3.zoomTransform(SVGElement);
};
exports.getZoomButtonStateOnChartLoad = function (minZoomRatio, maxZoomRatio) {
    return {
        disableZoomIn: maxZoomRatio === 1,
        disableZoomOut: minZoomRatio === 1,
        disableReset: true,
    };
};
exports.getZoomButtonStateOnChartZoom = function (minZoomRatio, maxZoomRatio, zoomState) {
    return {
        disableZoomIn: zoomState.k === maxZoomRatio,
        disableZoomOut: zoomState.k === minZoomRatio,
        disableReset: zoomState.k === 1,
    };
};
var calculateNewSmallScaleDomain = function (_a) {
    var smallScale = _a.smallScale, largeScale = _a.largeScale;
    var smallScaleTickIncrement = smallScale.ticks()[1] - smallScale.ticks()[0];
    var smallScaleTickNum = smallScale.ticks().length;
    var largeScaleTickNum = largeScale.ticks().length;
    var differenceInTickNum = largeScaleTickNum - smallScaleTickNum;
    var ticksToAddToBottom = Math.floor(differenceInTickNum / 2);
    var ticksToAddToTop = Math.ceil(differenceInTickNum / 2);
    var numberToAddToChartBottom = ticksToAddToBottom * smallScaleTickIncrement;
    var numberToAddToChartTop = ticksToAddToTop * smallScaleTickIncrement;
    var newScaleOneDomain = [
        smallScale.domain()[0] - numberToAddToChartBottom,
        smallScale.domain()[1] + numberToAddToChartTop,
    ];
    smallScale.domain(newScaleOneDomain).nice();
};
exports.createMatchingDualLinearAxisScales = function (scaleOne, scaleTwo) {
    var scaleOneTickNumber = scaleOne.ticks().length;
    var scaleTwoTickNumber = scaleTwo.ticks().length;
    if (scaleOneTickNumber === scaleTwoTickNumber)
        return;
    calculateNewSmallScaleDomain({
        smallScale: scaleOneTickNumber < scaleTwoTickNumber ? scaleOne : scaleTwo,
        largeScale: scaleOneTickNumber < scaleTwoTickNumber ? scaleTwo : scaleOne,
    });
};
exports.getTicksForDualAxisSize = function (scale, chartBreakPoints, chartHeight, mediumChartMaxTicks, largeChartMaxTicks) {
    if (chartHeight <= chartBreakPoints.small[1]) {
        return [scale.domain()[0], scale.domain()[1]];
    }
    var scaleYAxisTickValues = scale.ticks();
    if (scaleYAxisTickValues.length > largeChartMaxTicks) {
        scaleYAxisTickValues = scaleYAxisTickValues.filter(function (d, i) { return !(i % 2); });
    }
    if (chartHeight <= chartBreakPoints.medium[1] &&
        scaleYAxisTickValues.length > mediumChartMaxTicks) {
        scaleYAxisTickValues = scaleYAxisTickValues.filter(function (d, i) { return !(i % 2); });
    }
    return scaleYAxisTickValues;
};
exports.createDonutColorScale = function (d, r) {
    var willOverlap = d.length % r.length === 1;
    var customScale = function (_d, i) {
        if (i < r.length) {
            return r[i];
        }
        if (willOverlap) {
            return r[(i % r.length) + 1];
        }
        return r[i % r.length];
    };
    return customScale;
};
